var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheck(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#0C88ED"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.84853 10.1515C5.3799 9.68284 4.6201 9.68284 4.15147 10.1515C3.68284 10.6201 3.68284 11.3799 4.15147 11.8485L5.84853 10.1515ZM8 14L7.15147 14.8485C7.6201 15.3172 8.3799 15.3172 8.84853 14.8485L8 14ZM15.8485 7.84853C16.3172 7.3799 16.3172 6.6201 15.8485 6.15147C15.3799 5.68284 14.6201 5.68284 14.1515 6.15147L15.8485 7.84853ZM4.15147 11.8485L7.15147 14.8485L8.84853 13.1515L5.84853 10.1515L4.15147 11.8485ZM8.84853 14.8485L15.8485 7.84853L14.1515 6.15147L7.15147 13.1515L8.84853 14.8485Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.6da23ac9dd692bdd1caf32a868a9c171.svg";
export { ForwardRef as ReactComponent };